import React from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import TopImage from "../components/common/TopImage";

const TCPage = () => {
  const [enrollmentNumber, setEnrollmentNumber] = React.useState("");
  const [error, setError] = React.useState("");

  // Allowed enrollment numbers (filenames without .pdf)
  const pdf_files = [
    "449", "482", "612", "690", "1038", "1213", "1246", "1256",
    "1304", "1305", "1306", "1307", "1308", "1309",
    "1314", "1319", "1320", "1325", "1331", "1343"
  ];

  const commonButtonStyles =
    "justify-center self-center px-8 py-4 text-base tracking-wider text-center whitespace-nowrap rounded-2xl shadow-sm max-md:px-5";

  const handleDownload = () => {
    if (!enrollmentNumber) {
      alert("Please enter your enrollment number before downloading.");
      return;
    }

    if (!pdf_files.includes(enrollmentNumber)) {
      setError("TC not found for this enrollment number. Please contact the school.");
      return;
    }

    const baseURL = process.env.PUBLIC_URL + `/assets/TC/${enrollmentNumber}.pdf`;

    fetch(baseURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Something went wrong while downloading the TC.");
        }
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${enrollmentNumber}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setError("");
      })
      .catch((error) => {
        setError(error.message);
        console.error(error);
      });
  };

  const handleSampleDownload = () => {
    const baseURL = process.env.PUBLIC_URL + "/assets/Sample_TC.pdf";
    const link = document.createElement("a");
    link.href = baseURL;
    link.setAttribute("download", "Sample_TC.pdf");
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  return (
    <div>
      <NavBar />
      <TopImage text="Transfer Certificate (TC)" />

      <div className="flex flex-col items-center justify-center text-center mt-20 max-w-[746px] mx-auto">
        <div className="flex gap-5 justify-between px-5 w-full max-md:flex-wrap max-md:max-w-full">
          <div className="flex-auto mx-20 my-auto text-2xl font-bold tracking-wide text-black max-md:mt-20">
            Enrollment Number:
          </div>
          <div className="grow justify-center p-4 text-base text-center whitespace-nowrap rounded-2xl shadow-sm bg-zinc-200 text-zinc-800 max-md:px-6">
            <input
              className="text-center p-2 justify-center text-base bg-zinc-200 rounded-md placeholder w-60"
              type="text"
              value={enrollmentNumber}
              onChange={(e) => {
                setEnrollmentNumber(e.target.value);
                setError(""); // Clear error when typing
              }}
              placeholder="Enter the Enrollment number"
            />
          </div>
        </div>

        {/* Buttons and Error */}
        <div className="flex flex-col items-center gap-6 mt-20 mb-4 max-md:flex-col max-md:items-center">
          <div className="flex gap-6 max-md:flex-col">
            <div
              className={`bg-sky-700 text-zinc-100 hover:bg-sky-800 hover:shadow-lg cursor-pointer transition-all duration-300 ${commonButtonStyles}`}
              onClick={handleSampleDownload}
            >
              Sample TC
            </div>

            <div
              className={`bg-sky-700 text-zinc-100 hover:bg-sky-800 hover:shadow-lg cursor-pointer transition-all duration-300 ${commonButtonStyles}`}
              onClick={handleDownload}
            >
              Download
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div className="text-red-600 font-medium animate-pulse">
              {error}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TCPage;
